import {TRONWalletAdapter} from "../WalletAdapter";

export class TronLinkAdapter implements TRONWalletAdapter {
    name = "TronLink Wallet";
    website = "https://www.tronlink.org/"
    walletKey = "tronlink"

    async isInstalled() {
        return typeof window.tronWeb !== "undefined" && typeof window.tronLink !== "undefined"
    }

    async connect(): Promise<string> {
        if (!await this.isInstalled()) throw new Error("TronLink Wallet is not installed");
        if (!window.tronWeb.defaultAddress.base58) {
            await window.tronWeb.request(
                {
                    method: 'tron_requestAccounts',
                    params: window.tronLink.tronlinkParams,
                }
            )
        }
        if (!window.tronWeb.defaultAddress.base58) {
            throw new Error("Your should unlink your wallet and try again")
        }
        return window.tronWeb.defaultAddress.base58
    }

    async signMessage(message: string): Promise<string> {
        return await window.tronWeb.trx.signMessageV2(message)
    }
}
